import { request } from '../common/request'

export default {
    doLogin(account,password) {
        return request({
            url: "/doLogin",
            method: 'post',
            params: {
                account,
                password
            }
        })
    },


    viewUserTable(account, phone, identity, country, companyName,status,pageIndex) {
        return request({
            url: "/viewUserTable",
            method: 'get',
            params: {
                account,
                phone,
                identity,
                country,
                companyName,
                status,
                pageIndex
            }
        })
    },

    viewUserAll() {
        return request({
            url: "/viewUserAll",
            method: 'get',
        })
    },


    deleteUser(id) {
        return request({
            url: "/deleteUser",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateUser(user) {
        return request({
            url: "/updateUser",
            method: 'post',
            data: user,
        })
    },
    //修改密码
    fixPassword(param) {
        return request({
            url: "/fixPassword",
            method: 'post',
            data: param
        })
    },


    createUser(user) {
        return request({
            url: "/createUser",
            method: 'post',
            data: user,
        })
    },


    cusViewProductTable(fangshi,jiaohuodi, jiesuanfangshi, pinming, rezhiMin,rezhiMax, pageIndex) {
        return request({
            url: "/cusViewProductTable",
            method: 'get',
            params: {
                fangshi,jiaohuodi, jiesuanfangshi, pinming, rezhiMin, rezhiMax,pageIndex
            }
        })
    },

    viewProductById(id) {
        return request({
            url: "/viewProductById",
            method: 'get',
            params: {
                id
            }
        })
    },


    viewProductByMark(userId) {
        return request({
            url: "/viewProductByMark",
            method: 'get',
            params: {
                userId
            }
        })
    },


    viewProductByUser(userId,status,fangshi) {
        return request({
            url: "/viewProductByUser",
            method: 'get',
            params: {
                userId,status,fangshi
            }
        })
    },


    viewProductAll() {
        return request({
            url: "/viewProductAll",
            method: 'get',
        })
    },


    deleteProduct(id) {
        return request({
            url: "/deleteProduct",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateProduct(product) {
        return request({
            url: "/updateProduct",
            method: 'post',
            data: product,
        })
    },


    createProduct(product) {
        return request({
            url: "/createProduct",
            method: 'post',
            data: product,
        })
    },


    uploadFile(file,fileName) {
        const formData = new FormData();
        formData.append('file',file);
        formData.append('fileName',fileName);
        return request({
            url: "/uploadFile",
            method: 'post',
            data: formData
        })
    },


    viewUserGroupTable(groupName, usernames) {
        return request({
            url: "/viewUserGroupTable",
            method: 'get',
            params: {
                groupName,
                usernames,
            }
        })
    },


    deleteUserGroup(id) {
        return request({
            url: "/deleteUserGroup",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateUserGroup(userGroup) {
        return request({
            url: "/updateUserGroup",
            method: 'post',
            data: userGroup,
        })
    },


    createUserGroup(userGroup) {
        return request({
            url: "/createUserGroup",
            method: 'post',
            data: userGroup,
        })
    },


    viewDictionaryTable(name, value,pageIndex) {
        return request({
            url: "/viewDictionaryTable",
            method: 'get',
            params: {
                name,
                value,
                pageIndex
            }
        })
    },


    viewDictionaryAll() {
        return request({
            url: "/viewDictionaryAll",
            method: 'get',
        })
    },


    deleteDictionary(id) {
        return request({
            url: "/deleteDictionary",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateDictionary(dictionary) {
        return request({
            url: "/updateDictionary",
            method: 'post',
            data: dictionary,
        })
    },


    createDictionary(dictionary) {
        return request({
            url: "/createDictionary",
            method: 'post',
            data: dictionary,
        })
    },


    // 短信登陆
    aliVerify(param) {
        return request({
            url: "/aliVerify",
            method: 'post',
            params: {
                param
            }
        })
    },

    // 发送短信验证码
    sendPhoneVerificationCode(phone) {
        return request({
            url: "/sendPhoneVerificationCode",
            method: 'post',
            params: {
                phone,
            }
        })
    },


    doLoginWithPhone(phone,verificationCode) {
        return request({
            url: "/doLoginWithPhone",
            method: 'post',
            params: {
                phone,
                verificationCode
            }
        })
    },

    getUserInfo() {
        return request({
            url: "/getUserInfo",
            method: 'get',
        })
    },


    cusViewOrderBillTable(username, companyName, productName, jiesuanbizhong, beizhu, status, userId) {
        return request({
            url: "/cusViewOrderBillTable",
            method: 'get',
            params: {
                username,
                companyName,
                productName,
                jiesuanbizhong,
                beizhu,
                status,
                userId
            }
        })
    },


    deleteOrderBill(id) {
        return request({
            url: "/deleteOrderBill",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateOrderBill(orderBill) {
        return request({
            url: "/updateOrderBill",
            method: 'post',
            data: orderBill,
        })
    },


    createOrderBill(orderBill) {
        return request({
            url: "/createOrderBill",
            method: 'post',
            data: orderBill,
        })
    },


    viewMarkTable(userId, businessId, type) {
        return request({
            url: "/viewMarkTable",
            method: 'get',
            params: {
                userId,
                businessId,
                type,
            }
        })
    },


    deleteMark(id) {
        return request({
            url: "/deleteMark",
            method: 'post',
            params: {
                id
            }
        })
    },

    deleteMarkByUser(userId,businessId,type) {
        return request({
            url: "/deleteMarkByUser",
            method: 'post',
            params: {
                userId,businessId,type
            }
        })
    },


    updateMark(mark) {
        return request({
            url: "/updateMark",
            method: 'post',
            data: mark,
        })
    },


    createMark(mark) {
        return request({
            url: "/createMark",
            method: 'post',
            data: mark,
        })
    },


    viewCommentTable(userId, businessId, type, content) {
        return request({
            url: "/viewCommentTable",
            method: 'get',
            params: {
                userId,
                businessId,
                type,
                content,
            }
        })
    },


    deleteComment(id) {
        return request({
            url: "/deleteComment",
            method: 'post',
            params: {
                id
            }
        })
    },


    updateComment(comment) {
        return request({
            url: "/updateComment",
            method: 'post',
            data: comment,
        })
    },


    createComment(comment) {
        return request({
            url: "/createComment",
            method: 'post',
            data: comment,
        })
    },


    incrPhoneCount(productId) {
        return request({
            url: "/incrPhoneCount",
            method: 'post',
            params: {
                productId
            },
        })
    },

    getFlv() {
        return request({
            url: "/getFlv",
            method: 'get',
        })
    },

}
